import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import {getStowAssociatesForAssociateView} from "../../actions/AssociateActions";
import {connect} from "react-redux";
import Column from "@amzn/meridian/column";
import Options from "../Options";
import AssociateStatusOptions from "../options/AssociateStatusOptions";
import ClusterOptions from "../options/ClusterOptions";
import {getNodeId} from "../../Utility";
import {fetchCapability, fetchCycles, fetchFilters} from "../../actions/OptionsActions";
import {fetchCPTList} from "../../actions/OptionsActionsV2";
import AisleOptions from "../options/AisleOptions";
import AssociateTable from "./AssociateTable";
import {PageHeader} from "../utils/PageHeader";
import {FEATURES, HEADERS, OPTIONS_TAG_REQUIRED, refreshInterval} from "../../constants";
import {Capability} from "../../enums";
import {getFeaturesFromParent} from "../../handler/ParentDataHandler";
import {fetchFeatureStatusCallSuccess} from "../../actions/ConfigActions";
import FilterOptionsV2 from "../options/FilterOptionsV2";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

class Associate extends Component {

    timer;

    componentDidMount() {
        const nodeId = getNodeId();
        this.props.dispatch(fetchCapability());
        this.props.dispatch(fetchFilters(nodeId));
        getFeaturesFromParent([FEATURES.IS_CPT_FILTER_ENABLED]).then(featureStatusResponse => {
            this.props.dispatch(fetchFeatureStatusCallSuccess(featureStatusResponse.data))
        })
        if(this.props.featureStatus && this.props.featureStatus[FEATURES.IS_CPT_FILTER_ENABLED]){
            this.props.dispatch(fetchCPTList());
        }
        else
            this.props.dispatch(fetchCycles());
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        const {selectedCycle, CPTId, filterIdentifier, spacingInset_shorthand6} = this.props;
        this.fetchAssociates(selectedCycle, CPTId, filterIdentifier, this.isCPTFilterEnabled());
        const options = this.getApplicableOptions();
        return (
            <Column spacingInset={spacingInset_shorthand6}>
                <PageHeader {...HEADERS.ASSOCIATE}/>
                <Options options={options} optionsTagsRequired={OPTIONS_TAG_REQUIRED}/>
                <AssociateTable/>
            </Column>
        )
    }

    fetchAssociates(selectedCycle, CPTId, filterIdentifier, isCPTFilterEnabled) {
        clearInterval(this.timer);
        const nodeId = getNodeId();
        this.getStowAssociates(nodeId, selectedCycle, CPTId, filterIdentifier, isCPTFilterEnabled);
        this.timer = setInterval(() => {
            if (!document.hidden) {
                this.getStowAssociates(nodeId, selectedCycle, CPTId, filterIdentifier, isCPTFilterEnabled)
            }
        }, refreshInterval);
    }

    getStowAssociates = (nodeId, selectedCycle, CPTId, filterIdentifier, isCPTFilterEnabled) => {
        const capability = this.props.capability
        if (capability && Capability.AR_NEXT_GEN === capability) {
            this.props.dispatch(getStowAssociatesForAssociateView(nodeId, [], [], filterIdentifier, isCPTFilterEnabled));
        } else if (selectedCycle || CPTId) {
            this.props.dispatch(getStowAssociatesForAssociateView(nodeId, [selectedCycle],[CPTId], filterIdentifier, isCPTFilterEnabled));
        }
    }

    isCPTFilterEnabled = () => {
        return this.props.featureStatus && this.props.featureStatus[FEATURES.IS_CPT_FILTER_ENABLED];
    }

    getApplicableOptions = () => {
        switch (this.props.capability) {
            case Capability.SSD:
            case Capability.AMZL:
                return this.getApplicableOptionsForAmzl()
            case Capability.AR_NEXT_GEN:
                return this.getApplicableOptionsForArNextGen()
            default:
                return []
        }
    }

    getApplicableOptionsForAmzl = () => {
        return [
            {component: <FilterOptionsV2/>, name: "FilterOptionsV2"},
            {component: <AssociateStatusOptions/>, name: "AssociateStatusOptions"},
            {component: <ClusterOptions/>, name: "ClusterOptions"},
            {component: <AisleOptions/>, name: "AisleOptions"}
        ]
    }

    getApplicableOptionsForArNextGen() {
        return [
            {component: <AssociateStatusOptions/>, name: "AssociateStatusOptions"}
        ]
    }
}

// Adapter to convert class component to functional component.
function classToFunctionAdapter(CustomComponent) {
    return function WrappedComponent(props) {
        const {spacingInset_shorthand6} = useDeviceLayout();
        return <CustomComponent {...props} spacingInset_shorthand6={spacingInset_shorthand6}/>
    }
}

const mapStateToProps = state => ({
    capability: state.optionsReducerV2.capability,
    selectedCycle: state.optionsReducerV2.options.cycle,
    filterIdentifier: state.optionsReducerV2.filterIdentifier,
    CPTId: state.optionsReducerV2.options.CPTId,
    featureStatus: state.configReducer.featureStatus
});
export default withRouter(connect(mapStateToProps)(classToFunctionAdapter(Associate)));


// WEBPACK FOOTER //
// ./src/components/associate/Associate.js